import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from '@mui/material';
const Grey = styled('span')({
    color: 'GrayText',
});
const Italic = styled('span')({
    fontStyle: 'italic',
});
export const AppVersion = () => {
    const version = process.env.REACT_APP_CURRENT_DATE + '-' + process.env.REACT_APP_CURRENT_GIT_SHA;
    return (_jsxs(Typography, { paddingInline: 1, children: [_jsx(Grey, { children: "Version: " }), _jsx(Italic, { children: version })] }));
};
